import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';

import html2canvas from 'html2canvas';
import jspdf from 'jspdf';
import { CustomerService, SalesInqueryService, SalesOrderService } from '../../../services';
import { PackingDetails, ProductDetail, ProductDevelopment, ProductFeature, SalesInqueryBreackdown } from 'src/app/core/types';
import { NotificationService } from '../../notification/notification.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { CompanyDetails } from 'src/app/core/shared-data';
import { StringToJsonConversion } from 'src/app/core/JSON-conversions';

@Component({
  selector: 'app-npd-pdf',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './npd-pdf.component.html',
  styleUrls: ['./npd-pdf.component.scss']
})
export class NpdPdfComponent {
  @ViewChild('pdfContainer') pdfContainer!: ElementRef;
  @Output() closebtnEvent = new EventEmitter<boolean>();

  constructor(
    private salesOrderService: SalesOrderService,
    private customerService: CustomerService,
    private notificationService: NotificationService,
    private companyDetails: CompanyDetails

  ) { }

  ngOnInit() {
    let npd_id = sessionStorage.getItem("npd_id")
    if (npd_id) {
      this.getSalesOrderItemById(npd_id)
      this.getApprovals(npd_id)
    } else {
      this.notificationService.Error("Session read failed", "Unexpected Error")
    }
  }

  pdfVariables = {
    companyDetails: this.companyDetails.getCompanydetails(),
    inqueryType: "",
    // npdType: "",
    printed: "",
    npdNo: "",
    npdDate: "",
    inqNo: "",
    salesPerson: "",
    quoteNo: "",
    dueDate: "",

    customer: "",
    attentionTo: "",

    jobTitle: "",
    orderQuantity: 0,
    reqSampleQty: 0,
    sampleReceived: "",
    material: "",
    dimention: "",
    dimention_unit: "",
    colors: "",
    fcs: "",
    artworkapprovedDate: "",
    jobCompletedDate: "",
    finishings: [""],
    remarks: "",
    tblItems: Array(),

    windingDirection: "",
    upsPerReel: 0,
    lablesPerReal: 0,
    coreSize: 0,
    book_innerPages: 0,
    book_coverPages: 0,
    approvals: {
      approvedBy: "",
      createdBy: "",
    }
  }

  getSalesOrderItemById(id: string) {
    this.salesOrderService.getSalesOrderItemById(id).subscribe(
      (response) => {
        console.log(response.data);
        let data = response.data

        this.pdfVariables.approvals.approvedBy = data?.approvedBy?.employeeName ?? "-"

        this.pdfVariables.artworkapprovedDate = data?.artWorkApprovedDate ?? ""
        this.pdfVariables.npdDate = data?.salesOrder?.salesOrderDate ?? ""
        this.pdfVariables.dueDate = data?.customerRequestedDate ?? ""
        this.pdfVariables.jobTitle = data?.description ?? ""
        this.pdfVariables.inqNo = data.prRemark.salesInquiryNo ?? ""
        this.pdfVariables.salesPerson = data.prRemark.salesPerson.Name ?? ""

        this.pdfVariables.npdNo = data?.jobNumber ?? ""
        this.pdfVariables.customer = data?.salesOrder?.customer?.customerName ?? ""
        this.pdfVariables.attentionTo = data?.attentionTo ?? ""
        this.pdfVariables.quoteNo = data?.quotationBreakdown?.quotationNo ?? ""
        this.pdfVariables.remarks = data?.itemRemarks ?? ""

        this.pdfVariables.orderQuantity = 0
        this.pdfVariables.reqSampleQty = data?.salesOrderItemBreakdowns.reduce((accumulator: any, currentItem: { quantity: any; }) => accumulator + currentItem.quantity, 0);

        let productDetail: ProductDetail = {
          description: "",
          orderNo: "",
          packingDate: "",
          expiryDate: "",
          batchNo: "",
          productCode: ""
        }
        let pdRemark: ProductDevelopment = {
          noOfFullSheet: 0,
          noOfCutSheet: 0,
          fullSheetSize: "",
          cutSheetSize: "",
          noOfCuts: 0,
          noOfUps: 0
        }
        let pdRemarkDescription: any

        try {
          let pdrJsonString = data.prRemark.pdRemark.replace(/\\/g, '')
          // Remove surrounding double-quotes, if any
          pdrJsonString = pdrJsonString.replace(/^"(.*)"$/, '$1')

          pdRemarkDescription = data.prRemark.description

          const productFeature: ProductFeature = JSON.parse(data.prRemark.productFeature)
          const packingDetails: PackingDetails = JSON.parse(data.prRemark.packingDetails)

          this.pdfVariables.windingDirection = packingDetails.windingDirection ?? ""
          this.pdfVariables.coreSize = packingDetails.coreSize ?? 0
          this.pdfVariables.lablesPerReal = packingDetails.pcsPerRoleSheet ?? 0
          this.pdfVariables.upsPerReel = packingDetails.up ?? 0
          this.pdfVariables.printed = packingDetails.printedOrNot ?? ""


          this.pdfVariables.fcs = (productFeature?.productFeatureSpecs?.fsc ?? false) ? "YES" : "NO"

          this.pdfVariables.book_innerPages = productFeature.productFeatureSpecs?.book_noOfInnerPages ?? 0
          this.pdfVariables.book_coverPages = productFeature.productFeatureSpecs?.book_noOfCoverPages ?? 0

          this.pdfVariables.material = productFeature?.productFeatureSpecs?.board ?? "NULL"
          this.pdfVariables.colors = `${productFeature?.productFeatureSpecs?.noOfColors ?? "NULL"}`
          this.pdfVariables.dimention = `${productFeature?.productFeatureSpecs?.dimention ?? "NULL"}`
          this.pdfVariables.dimention_unit = `${productFeature?.productFeatureSpecs?.dimention_unit ?? "NULL"}`
          this.pdfVariables.finishings = productFeature.productFinishings.map(item => item.productFeatureCode)

        } catch (error) {
          console.log(error);
        }

        let soiBreackdowns = data.salesOrderItemBreakdowns
        console.log(data.salesOrderItemBreakdowns);

        if (soiBreackdowns) {
          for (let item of soiBreackdowns) {
            let breackdownDetailString = item.salesOrderItemBreakdownDetails.replace(/\\/g, '"') ?? "{}"
            let breackdownDetail: ProductDetail = JSON.parse(breackdownDetailString)

            let tableItem = {
              description: breackdownDetail.description ?? "-",
              quantity: item.quantity ?? "-",
              packingDate: breackdownDetail.packingDate ?? "-",
              expieryDate: breackdownDetail.expiryDate ?? "-",
              batchNo: breackdownDetail.batchNo ?? "-",
            }
            this.pdfVariables.tblItems.push(tableItem)
          }
        }
        console.log(this.pdfVariables.tblItems);
      },
      (error) => {
        console.log(error);

      }
    )
  }

  async getApprovals(id: string) {
    try {
      const salesOrderItemApprovalResponse = await this.salesOrderService.getSalesOrderItemApprovals(id).toPromise()
      const salesOrderItemApproData = salesOrderItemApprovalResponse?.data

      this.pdfVariables.approvals.createdBy = salesOrderItemApproData?.salesOrderCreatedPerson?.displayName ?? "-"


    } catch (error) {
      console.log(error);
      this.notificationService.Error("Error getting job approval data")
    }
  }


  // getCustomerById(id: number) {
  //   this.customerService.getCustomerById(id.toString()).subscribe(
  //     (response) => {
  //       this.pdfVariables.customerDetails.contact = response.data.telephoneNo
  //     }, (error) => {
  //       console.log(error);

  //     }
  //   )
  // }

  convertToPDF() {
    let pdfName = `sales_inquery-${this.pdfVariables.npdNo}`

    var data = document.getElementById('contentToConvert');
    if (data) {
      html2canvas(data, { scale: 3 }).then(canvas => {
        console.log(canvas);
        // Few necessary setting options
        var imgWidth = 210;
        var pageHeight = 297;
        var imgHeight = canvas.height * imgWidth / canvas.width;
        var heightLeft = imgHeight;

        const contentDataURL = canvas.toDataURL('image/png');
        let pdf = new jspdf('p', 'mm', 'a4'); // A4 size page of PDF
        var position = 0;
        // pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight, '', 'SLOW');
        pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight, '', 'SLOW');
        pdf.save(pdfName); // Generated PDF
      });
    }
  }

  closePdf() {
    this.closebtnEvent.emit(true);
  }

  @ViewChild('pdfPage') pdfPage!: ElementRef;
  zoomLevel = 1;

  zoomIn() {
    this.zoomLevel += 0.1;
    this.applyZoom(this.zoomLevel);
  }

  zoomOut() {
    this.zoomLevel -= 0.1;
    this.applyZoom(this.zoomLevel);
  }

  applyZoom(zoomLevel: number) {
    const el = this.pdfPage.nativeElement;
    el.style.transform = `scale(${zoomLevel})`;
  }

}
